import { tableColors } from './palette';

export const tableOverrides = {
    MUIDataTable: {
        responsiveScroll: {
            maxHeight: 'inherit'
        },
        responsiveScrollMaxHeight: {
            maxHeight: 'inherit'
        }
    },
    MuiTableRow: {
        root: {
            '&$hover:hover': {
                backgroundColor: `${tableColors.tableRowHover} !important`,
                cursor: 'pointer'
            },
            '&$selected': {
                backgroundColor: `${tableColors.tableRowSelected} !important`
            },
            '&:nth-child(odd)': {
                backgroundColor: tableColors.tableRowBackground
            }
        },
        head: {
            backgroundColor: `${tableColors.defaultBackground} !important`
        }
    },
    MuiTableCell: {
        head: {
            whiteSpace: 'nowrap',
            padding: '5px !important',
            '&:first-child': {
                paddingLeft: '10px !important'
            }
        },
        body: {
            whiteSpace: 'nowrap',
            padding: '5px 10px !important',
            '&:nth-child(2)': {
                paddingLeft: '10px !important'
            },
            fontSize: '0.875rem',
            fontWeight: 500,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 320
        },
        paddingCheckbox: {
            width: 40
        }
    }
};